import { RequestTokenEditModel } from "@playcharge/common/models/backend/auth/request-token-edit-model";
import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { TokenViewModel } from "@playcharge/common/models/backend/auth/token-view-model";
import { BehaviorSubject, Observable } from "rxjs";
import { ApiUtils } from "../utils/api-utils";
import { ApiRoutes } from "../models/constants/api-routes";
import { Platform } from "@playcharge/common/models/backend/auth/platform";
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: "root",
})
export class ApiAuthService {
    private _httpClient = inject(HttpClient);

    public signIn(email: string, password: string): Observable<TokenViewModel> {
        return this._httpClient.post<TokenViewModel>(
            ApiUtils.buildIdentityUrl(ApiRoutes.auth.signIn),
            this.buildTokenRequestModel(email, password),
        );
    }

    public refreshToken(): Observable<TokenViewModel> {
        return this._httpClient.post<TokenViewModel>(
            ApiUtils.buildIdentityUrl(ApiRoutes.auth.refresh),
            this.buildTokenRequestModel(null, null),
        );
    }

    public logout(): Observable<void> {
        return this._httpClient.post<void>(ApiUtils.buildIdentityUrl(ApiRoutes.auth.logout), null);
    }

    private buildTokenRequestModel(
        email: string | null,
        password: string | null,
    ): RequestTokenEditModel {
        return {
            email: email,
            name: null,
            version: environment.version,
            password: password,
            referralId: null,
            grantType: "password",
            clientType: "BackofficeUser",
            platform: Platform.Web,
            ip: null,
            userAttribution: null,
            browser: null,
            operationSystem: null,
            device: null,
            deviceType: null,
            idfa: null,
            partnerId: null,
            clickId: null,
            partnerExtraParams: null,
        };
    }
}
